import store from '@/reducers';
import { useEffect } from 'react';
const useSimpleLogger = () => {
  const getUserId = () => store.getState().users.uid;

  // 检查是否为需要记录日志的路由
  const isLoggedRoute = (path) => {
    const patterns = ['/edu/ailab/', '/ailab/'];
    return patterns.some(
      (pattern) => path.includes(pattern) && path.length > pattern.length,
    );
  };

  const sendLog = (endpoint, logData) => {
    let { VITE_BASENAME, VITE_ORIGIN } = import.meta.env;
    const url = VITE_ORIGIN + VITE_BASENAME;
    fetch(`${url + endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(logData),
    }).catch((error) => {
      console.error('日志发送失败:', error);
    });
  };

  // AI体验区的页面进入和离开日志
  const usePageLogger = (path) => {
    const logPageEnter = () => {
      if (isLoggedRoute(path)) {
        const logData = {
          user_id: getUserId(),
          type: 0, // 0: 进入
          path,
        };
        sendLog('/api/log/experience', logData);
      }
    };

    const logPageLeave = () => {
      if (isLoggedRoute(path)) {
        const logData = {
          user_id: getUserId(),
          type: 1, // 1: 离开
          path,
        };
        sendLog('/api/log/experience', logData);
      }
    };

    return { logPageEnter, logPageLeave };
  };

  // 课件操作日志(预览pdf/word/点击下载课件等)
  const logCourseMaterial = (actionType, filename, courseId, sessionId) => {
    const logData = {
      user_id: getUserId(),
      type: actionType, // 0: 点击/进入, 1: 预览/下载
      filename: filename || undefined, // 如果filename为null，则设为undefined
      course_id: courseId,
      session_id: sessionId || undefined,
    };
    sendLog('/api/log/edu', logData);
  };

  // 新增：自动记录课程页面访问日志
  const useCourseLogger = (path) => {
    useEffect(() => {
      // 支持两种课程路径格式
      if (path.includes('/course/')) {
        const courseId = path.split('/').pop(); //路径的最后一部分
        logCourseMaterial(0, null, courseId, null);
      }
    }, [path]);
  };

  // 直接发送体验区进入日志（用于外部链接等非路由场景）
  const logExperienceEnter = (path) => {
    if (isLoggedRoute(path)) {
      const logData = {
        user_id: getUserId(),
        type: 0, // 0: 进入
        path,
      };
      sendLog('/api/log/experience', logData);
    }
  };

  return {
    usePageLogger,
    logCourseMaterial,
    useCourseLogger,
    logExperienceEnter,
  };
};

export default useSimpleLogger;
